import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ContentComponent } from '../content/content.component';
import { SingleCardLayoutComponent } from '../single-card-layout/single-card-layout.component';
import { ButtonComponent } from '../button/button.component';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-not-found-page',
  imports: [ContentComponent, SingleCardLayoutComponent, ButtonComponent],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent {
  private readonly router: Router = inject(Router);

  public home(): void {
    this.router.navigate(['/home']);
  }
}
